import { derived, writable } from "svelte/store";
export const flows = writable([]);
export const selectedFlow = writable(null);
export const flowItems = writable([]);
export const procentPassed = writable(0);
export const activeFlowItems = derived(flowItems, $flowItems => $flowItems.filter(((flowItem) => flowItem.is_enabled)));
export const disabledFlowItems = derived(flowItems, $flowItems => $flowItems.filter(((flowItem) => !flowItem.is_enabled)));
